'use client';

import { useMediaType } from '@packages/shared/src/hooks/useMediaType/useMediaType';
import { ErrorBoundary } from '@packages/shared/src/ui/ErrorBoundary/ErrorBoundary';
import type { CmsData } from '../../../interfaces/webapp_json';
import { registerFlexibleComponentsFooter } from '../../components/ComponentRecognizer/registerFlexibleComponentsFooter';
import { CookieConsentManager } from '../../components/CookieConsentManager/CookieConsentManager.client';
import { AreaSocket } from '../../components/Footer/AreaSocket/AreaSocket';
import { AreaTop } from '../../components/Footer/AreaTop/AreaTop';
import { BlockContent } from '../../components/Footer/BlockContent/BlockContent';
import { FooterAccordion } from './FooterAccordion';
import { FooterFallbackError } from './FooterFallbackError';

// register the dynamic components
registerFlexibleComponentsFooter();

type PageRendererProps = {
  data: CmsData;
  socketOnly?: boolean;
};

export const PageRenderer = ({ data, socketOnly = false }: PageRendererProps) => {
  const isDesktop = useMediaType();

  return (
    <>
      {!socketOnly && <AreaTop data={data} />}
      <footer
        className={`bg-color-footer-main text-color-footer-contrasttext [&_button]:text-color-footer-contrasttext [&&_a]:text-color-footer-contrasttext ${socketOnly ? 'mt-[5.75rem]' : 'mt-6.5'} lg:mt-auto [&_p_a]:hover:underline! lg:[&.footer_block_badges]:flex lg:[&.footer_block_badges]:gap-3 lg:[&>p]:m-0 lg:[&>p+_p]:pt-1`}
      >
        {!socketOnly && (
          <ErrorBoundary fallback={<FooterFallbackError />}>
            {isDesktop ? <BlockContent data={data} /> : <FooterAccordion data={data} />}
          </ErrorBoundary>
        )}
        <CookieConsentManager>
          <AreaSocket data={data} />
        </CookieConsentManager>
      </footer>
    </>
  );
};
